export const ENABLE_REPORTS = 'REACT_APP_REPORTS_ENABLE';

export const ENABLE_LEAGUES = 'REACT_APP_ENABLE_LEAGUES';
